export default {
  blogposts(state) {
    return state.blogposts;
  },
};
